import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Provider } from 'react-redux';
import store from '../store';
const AppProvider = ({ children }) => (_jsx(Provider, Object.assign({ store: store }, { children: children })));
export default AppProvider;
